import { Markdown } from "../components/Markdown"
import { SplashTemplate } from "../templates/SplashTemplate"

export function SplashPage() {
  return (
    <SplashTemplate title="Blake & Christie">
      <Markdown path="splash.md" />
    </SplashTemplate>
  )
}
